import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/internal/observable/of';
import { Storage } from '@ubud/storage';
import { fromPromise } from 'rxjs-compat/observable/fromPromise';

/**
 *  @author     Arif Setianto <arifsetiantoo@gmail.com>
 *  @created    09/11/2019
 */
@Injectable()
export class RedirectUriGuard implements CanActivate {
    public constructor(private storage: Storage) {}

    public canActivate(route: ActivatedRouteSnapshot, router: RouterStateSnapshot): Observable<boolean> {
        if (router.url) {
            fromPromise(this.storage.set('redirect_uri', router.url));
            return of(true);
        }

        return of(false);
    }
}



// WEBPACK FOOTER //
// ./src/lemsar/auth/guards/redirect-uri.guard.ts